/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import LinklawEditing from './linklawediting';
import LinklawUI from './linklawui';

export default class Linklaw extends Plugin {
	static get requires() {
		return [ LinklawEditing, LinklawUI ];
	}
}